export interface FilterChip {
  label: string;
  onRemove: () => void;
}

// Removable chips for every filter currently applied, plus a clear-all button.
const ActiveFilters = ({
  chips,
  onClearAll,
}: {
  chips: FilterChip[];
  onClearAll: () => void;
}) => {
  if (!chips.length) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap px-5 pb-4">
      <span className="text-xs text-hcMuted">Filters:</span>
      {chips.map((c) => (
        <span
          key={c.label}
          className="inline-flex items-center gap-1.5 bg-hc_F4EBFA text-honeConnectPurple text-xs font-medium pl-3 pr-1.5 py-1 rounded-full"
        >
          {c.label}
          <button
            type="button"
            aria-label={`Remove ${c.label}`}
            onClick={c.onRemove}
            className="w-4 h-4 rounded-full hover:bg-honeConnectPurple hover:text-white flex items-center justify-center leading-none"
          >
            ×
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onClearAll}
        className="text-xs font-semibold text-honeConnectGray hover:text-honeConnectPurple underline"
      >
        Clear all
      </button>
    </div>
  );
};

export default ActiveFilters;
